import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc
} from "firebase/firestore";
import { db } from "../firebase";

const raceCollection = collection(db, "races");

// CREATE
export const addRace = async (data) => {
  return await addDoc(raceCollection, {
    ...data,
    created_at: new Date()
  });
};

// READ
export const getRaces = async () => {
  const snapshot = await getDocs(raceCollection);
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data()
  }));
};

// UPDATE
export const updateRace = async (id, data) => {
  const raceDoc = doc(db, "races", id);
  return await updateDoc(raceDoc, data);
};

// DELETE
export const deleteRace = async (id) => {
  const raceDoc = doc(db, "races", id);
  return await deleteDoc(raceDoc);
};